import { register } from "@rill/loader";

register(
  {
    name: "snapshot",
    meta: ["snapshot"],
  },
  async ({ api }, { snapshot }) => {
    if (!snapshot) return;
    try {
      return await (await api(`snapshot/${snapshot}`)).json();
    } catch (_) {}
  }
);
